import { yupResolver } from "@hookform/resolvers/yup";
import FormProvider, {
  RHFAutocomplete,
  RHFTextField,
} from "src/components/hook-form";
import * as Yup from "yup";

import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import StudentController from "src/controller/Student.controller";

// ----------------------------------------------------------------------

AddTopicDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.array,
  learningPlan: PropTypes.object,
};

export default function AddTopicDialog({ open, onClose, data, learningPlan }) {
  const [topic, setTopic] = useState([]);
  const [loadingSend, setLoadingSend] = useState(false);

  const CategorySchema = Yup.object().shape({
    topic: Yup.string().required("Topic is required."),
    sub_topic: Yup.string().required("Sub-Topic is required."),
  });

  const defaultValues = {
    topic: "",
    sub_topic: "",
  };

  const methods = useForm({
    resolver: yupResolver(CategorySchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    reset,
    formState: { isSubmitting },
    setError,
    control,
  } = methods;

  const onSubmit = async (formData) => {
    StudentController.createQuestionToLearningPlan(learningPlan.id, formData)

      .then((res) => {
        window.Toast("Question added successfully");
        onClose();
        reset(defaultValues);
      })
      .catch((err) => {
        setError("afterSubmit", { message: err.message });
        setLoadingSend(false);
      });
  };

  const handleClosePopUp = () => {
    reset(defaultValues);
    onClose();
  };

  useEffect(() => {
    if (learningPlan) {
      const topics = new Set();

      if (Array.isArray(learningPlan?.questions)) {
        for (let index = 0; index < learningPlan?.questions.length; index++) {
          const element = learningPlan?.questions[index];
          topics.add(element.topic);
        }
      }
      setTopic(Array.from(topics));
    }
  }, [learningPlan]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClosePopUp}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Add Topic</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2} paddingTop={1}>
            <RHFAutocomplete
              fullWidth
              size="small"
              name="topic"
              label="Topic"
              placeholder="topic"
              ChipProps={{ size: "small" }}
              options={topic}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              freeSolo
              onChange={(e, value) => {
                setValue("topic", value ?? "");
              }}
              onInputChange={(e, value) => {
                setValue("topic", value);
              }}
            />
            <RHFTextField size="small" name="sub_topic" label="Sub Topic" />
          </Stack>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Add
          </LoadingButton>

          <Button color="error" variant="contained" onClick={handleClosePopUp}>
            Cancel
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
